import script from "./AgentSettingsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentSettingsPage.vue?vue&type=script&setup=true&lang=js"

import "./AgentSettingsPage.vue?vue&type=style&index=0&id=272d42fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-272d42fa"]])

export default __exports__